import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import brands from './brands';
import smsRegistrations from './smsRegistrations';
import campaigns from './campaigns';
import numbers from './numbers';
import vettings from './vettings';
import getters from './getters';
import enums from './enums';
import mutations from './mutations';
import otp from "@/store/otp";

Vue.use(Vuex);

export const INITIAL_STATE = {
    apiKeys: [],
    user: {},
    credentials: {},
    accountDetails: {},
    showPricing: false,
};

export default new Vuex.Store({
    state: { ...INITIAL_STATE },
    actions,
    mutations,
    getters,
    // Only validate stuff in development mode
    strict: false,
    modules: {
        brands,
        enums,
        campaigns,
        numbers,
        vettings,
        smsRegistrations,
        otp,
    }
});

